/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import TextAreaWithCount from "components/text-area/text-area-with-count";
import { getErrorMessage } from "pages/story-editor/utils";
import { t } from "i18n";

const MetaDescription = ({ value, spec, onChange, errors, disabled }) => (
  <TextAreaWithCount
    label={t("story-editor.inspector.meta-description")}
    maxValue={spec["validations"]["hard-limit"] || 140}
    value={value}
    onChange={onChange}
    errorMessage={getErrorMessage(errors)}
    disabled={disabled}
  />
);

export default MetaDescription;
